import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import UploadRecordFiles from './UploadRecordFiles';
import Dialog from '@material-ui/core/Dialog';
import BackDropLoading from '../../../../models/BackDrop';
import StyledDialog from '../../../../../../../common/models/Dialog';
import { useDispatch } from 'react-redux';
import { DESTROY_BACKDROP, OPEN_BACKDROP } from '../../../../../../containers/actions/types';
import axios from 'axios';
import { appUrl } from '../../../../../../../../utils/config';


const useStyles = makeStyles(() => ({
  backgroundGrid: {
    backgroundColor: '#ffffff',
    borderRadius: '1rem',
  },

}));


const NewRecord = (props) => {
  const dispatch = useDispatch()
  const { batchDetails } = props;
  const classes = useStyles()
  const [stateObj, setState] = useState({
    disableNext: false,
    uploadedRecordsFileName: '',
    uploadedRecordsFiles: {},
    resError: null,
    confirmDialog: false,
    disableUploadButton: false,
    errorMessageColor: 'black',
  })

  const handlingFiles = (file) => {
    if (file) {
      setState({
        ...stateObj,
        uploadedRecordsFileName: file.name,
        uploadedRecordsFiles: file,
        resError: null,
        errorMessageColor: 'black',
      });
    }
  };

  const handleDeleteRecord = () => {
    setState({
      ...stateObj,
      uploadedRecordsFiles: {},
      uploadedRecordsFileName: '',
      resError: null,
      errorMessageColor: 'black',
    });
  };
  //close confirmation dialog
 const  handleCloseRecord = () => {
    setState({
      confirmDialog: false,
    });
    props.handleClose();
  };

  const handleUpload = () => {
    dispatch({
          type: OPEN_BACKDROP,
    });
    
    let batchData = {
      collabrixWorkItemID: 0,
   collabrixBatchID: batchDetails.schrockenDeliveryScheduleBatchID,
   sponsorOrgID: batchDetails.brandOwnerMosymphonyID,
   cdmoOrgID: batchDetails.vendorMosymphonyID,
    }

    //console.log(batchData)

    const data = new FormData();
    data.append('files', stateObj.uploadedRecordsFiles);
    data.append('data', JSON.stringify(batchData))

  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addBatchUnitOperationDetailsExcel`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        setState({
          ...stateObj,
          confirmDialog: true
        });
        dispatch({type: DESTROY_BACKDROP,});
      } else {
        setState({
          ...stateObj,
          resError: "Something went wrong. Please try again."
        });
        dispatch({type: DESTROY_BACKDROP,});
      }
    })
    .catch((err) => {
      dispatch({ type: DESTROY_BACKDROP, });
      setState({
        ...stateObj,
        resError: "Something went wrong. Please try again."
      });
      console.log(err)
    });
    
    // setTimeout(() => {
    //   // setState({
    //   //   ...stateObj,
    //   //   confirmDialog: true
    //   // });
    //         setState({
    //     ...stateObj,
    //     resError: "Something went wrong. Please try again."
    //   });
    //   dispatch({type: DESTROY_BACKDROP,});
    // }, 5000);
  }

  return (
    <React.Fragment>
        <Grid container justify='center'>
          <Grid
            item
            xs={11}
            sm={10}
            md={12}
            lg={12}
            xl={12}
            className={classes.backgroundGrid}
          >
            <Grid container justifyContent='center'>
              <Grid item xs={12} md={9} lg={8} xl={6}>
              <UploadRecordFiles
              handlingFiles={handlingFiles}
              handleDeleteRecord={handleDeleteRecord}
              fileName={stateObj.uploadedRecordsFileName}
              resError={stateObj.resError}
              handleUpload={handleUpload}
              disableUploadButton={stateObj.disableUploadButton}
              errorMessageColor={stateObj.errorMessageColor}
            />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Dialog open={stateObj.confirmDialog} fullWidth>
          <StyledDialog
            handleClose={handleCloseRecord}
            icons={true}
            title='Details Saved Successfully'
            subtitle='Your record has been added/updated. Please Contact the Admin if you have Entered the Wrong Data.'
          />
      </Dialog>
      <BackDropLoading />
      </React.Fragment>
  )
}

export default NewRecord
